import * as React from 'react';
import styled from 'styled-components';
import Checkbox from 'rc-checkbox';
import { Link } from 'react-router-dom';

const TermsOfServiceContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const TermsOfServiceText = styled.p`
  font-family: Inter UI;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: normal;
  margin-top: 0px;
  margin-bottom: 0px;

  color: #00144d;

  margin-left: 8px;
`;

const StyledLink = styled(Link)`
  font-weight: 500;
  font-size: 12px;
  line-height: normal;
  text-decoration: underline !important;

  color: #00144d;
  :hover {
    cursor: pointer;
  }
`;

interface TermsOfServiceProps {
  onChange?: (e: any) => void;
  checked: boolean;
}

class TermsOfService extends React.Component<TermsOfServiceProps, any> {
  render() {
    return (
      <TermsOfServiceContainer>
        <Checkbox checked={this.props.checked} onChange={this.props.onChange} />
        <TermsOfServiceText>
          I accept the{' '}
          <StyledLink to="/terms-of-service" target="_blank">
            {' '}
            Terms of Service
          </StyledLink>
          .
        </TermsOfServiceText>
      </TermsOfServiceContainer>
    );
  }
}

export default TermsOfService;



// WEBPACK FOOTER //
// ./src/pages/MatchPage/components/TermsOfService.tsx